import {resetPlateEditorStateOnChangeView} from 'stores/business/plateTypeEditorBusiness';
import * as actiontypes from '../../constants/actionType';
import {ViewMode} from '../../constants/dataEnum';
// eslint-disable-next-line import/no-cycle
import {saveState} from '../business/stateBusiness';
import {clearWizardFlag} from './wizardStateAction';

const DEFAULT_SNACKBAR_TIMEOUT = 5000;

export function changeView(view) {
  return (dispatch, getstate) => {
    console.info(`access ${view} page`);
    const state = getstate();
    const {appState} = state;
    const prevView = appState.viewMode;

    if (view === prevView) return;

    dispatch({type: actiontypes.CHANGE_VIEW, view, prevView});

    if (view === ViewMode.LOGIN || view === ViewMode.LOGIN_CONFIRMATION) {
      return;
    }

    if (prevView === ViewMode.PLATE_TYPE_EDITOR) {
      dispatch(resetPlateEditorStateOnChangeView());
    }

    dispatch(saveState(false));
  };
}

export function setOverrideBeforeUnload(isOverride) {
  return (dispatch) => {
    dispatch({type: actiontypes.OVERRIDE_BEFORE_UNLOAD, isOverride});
  };
}

export function hideSnackbar() {
  return (dispatch, getState) => {
    const {appState} = getState();
    const snackbar = {
      ...appState.snackbar,
      show: false,
      text: '',
      autoHide: true,
      disableBlur: true,
      actionButton: null,
      buttonLabel: '',
    };
    dispatch({type: actiontypes.SHOW_SNACKBAR, snackbar});
  };
}

let snackbarTimeout;

export function showSnackbar(
  // eslint-disable-next-line default-param-last
  style = '',
  text,
  timeoutParam,
  autoHide = true,
  disableBlur = true,
  actionButton = null,
  buttonLabel = '',
  title = null,
) {
  return (dispatch) => {
    if (snackbarTimeout) {
      clearTimeout(snackbarTimeout);
      snackbarTimeout = null;
    }

    // eslint-disable-next-line no-unsafe-optional-chaining
    const calculateTimeout = () => (typeof text === 'string' ? (text?.length / 20) * 1200 : DEFAULT_SNACKBAR_TIMEOUT);

    const timeout = timeoutParam || calculateTimeout();

    const snackbar = {
      show: true,
      style: style || '',
      text: text || '',
      timeout,
      autoHide,
      useActionButton: Boolean(actionButton),
      disableBlur,
      title,
    };

    if (actionButton) {
      snackbar.actionButton = () => {
        dispatch(hideSnackbar());
        actionButton();
      };
      snackbar.buttonLabel = buttonLabel;
    }

    dispatch({type: actiontypes.SHOW_SNACKBAR, snackbar});

    if (autoHide) {
      snackbarTimeout = setTimeout(() => {
        dispatch(hideSnackbar());
        snackbarTimeout = null;
      }, timeout);
    }
  };
}

export function showLoading(text, onCancel) {
  return (dispatch, getState) => {
    const {viewMode} = getState();
    const loading = {
      show: true,
      text: text || 'Loading ...',
      onCancel,
    };

    if (viewMode === ViewMode.SETUP_WIZARD) dispatch(clearWizardFlag());
    dispatch({type: actiontypes.SHOW_LOADING, loading});
  };
}

export function updateCancelLoading(onCancel) {
  return (dispatch, getState) => {
    const {loading} = getState().appState;
    if (loading) {
      dispatch({
        type: actiontypes.UPDATE_LOADING,
        loading: {
          ...loading,
          onCancel,
        },
      });
    }
  };
}

export function hideLoading() {
  return (dispatch) => {
    dispatch({type: actiontypes.HIDE_LOADING});
  };
}

export const setDrawerVisibility = (data) => ({
  type: actiontypes.SET_DRAWER_VISIBILITY,
  data,
});

export const setTriggerRebuildConnection = (data) => ({
  type: actiontypes.TRIGGER_REBUILD_CONNECTION,
  data,
});

export const setHeadChannelsConfigOpen = (data) => ({
  type: actiontypes.SET_HEAD_CHANNELS_CONFIG_OPEN,
  data,
});

export const setIsAnyModalShow = (isShow) => ({
  type: actiontypes.SET_IS_ANY_MODAL_SHOW,
  isShow,
});

export function restoreAppState(state) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.RESTORE_APPSTATE,
      state,
    });
  };
}

export function setIsManualReteachPage() {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_IS_MANUAL_RETEACH_PAGE});
  };
}

export function resetIsManualReteachPage() {
  return (dispatch) => {
    dispatch({type: actiontypes.RESET_IS_MANUAL_RETEACH_PAGE});
  };
}

export const setIsRestoringSoftware = (isRestoring) => ({
  type: actiontypes.SET_IS_RESTORING_SOFTWARE,
  isRestoring,
});
